export default __webpack_public_path__ + "static/screenSixthSectionEnBig-0575d747a5ca12608d37d0e787acb807.webp";